import generatePDF from './generatePdf';
import PrimaryButton from '../button/PrimaryButton';
import generateInvoice from './intermarche/generateInvoice';

const InvoiceButton = ({ invoiceData }) => {
  const isIntermarche = invoiceData?.store?.name?.toLowerCase().includes('intermarché')
    || invoiceData?.store?.name?.toLowerCase().includes('intermarche');

  const handleDownload = () => isIntermarche ? generateInvoice(invoiceData) : generatePDF(invoiceData);

  return (
    <div className="text-center text-black relative font-light text-[1.7rem] w-[90%] -mt-10 mb-6">
      <PrimaryButton
        className="rounded-tl-none rounded-tr-none"
        label={"Télécharger mon ticket"}
        onClick={handleDownload}
      />
    </div>
  );
};

export default InvoiceButton;
